import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";
export default async function endTrip(trip_id, component) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  const resp = await fetch(`${API_URL}rest/V1/rider/endtrip`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      jobId: trip_id,
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      window.location.reload();
      return response.json();
    })
    .then(function (data) {
      if (data[0] && data[0].status === "success") {
        api.getcompletedjobs(component);
        component.props.actionProcessingJobs("failure");
      }
      return data;
    });
  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/endTrip.js